import {
  Box,
  styled,
  TableRow,
  TableCell,
  Button,
  Grid,
  TextField,
  InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React, { useEffect, useState } from 'react';
import PageHeader from '../../../components/PageHeader';
import Table from '../../../components/Table';

import IOSSwitch from '../../../components/IOSSwitch';
import { Area } from '../../../schema/area';
import { Link } from 'react-router-dom';
import { TableResponse } from '../../../schema/helper';
import { api } from '../../../api';
import AreaZoneFromInput from '../../../components/formInput/AreaZoneFromInput';

const tableHead = ['รหัสพื้นที่', 'ชื่อพื่นที่', 'Zone', 'ต้องการ work permit', 'เพิ่มเติม'];

const AreaPage: React.FC = () => {
  const [data, setData] = useState<TableResponse<Area> | null>(null);

  const [filterName, setFilterName] = useState<string>('');
  const [filterCode, setFilterCode] = useState<string>('');
  const [filterZoneId, setFilterZoneId] = useState<number | null>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const updateAreaData = (area_id: number, { is_require_wpm }: { is_require_wpm: boolean }) => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    api
      .patch(`/area/${area_id}`, {
        is_require_wpm: is_require_wpm ? true : false
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (filterName == '' && filterCode == '' && filterZoneId == null) {
      const searchParams = new URLSearchParams();
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);
      api.get<TableResponse<Area>>(`/area/table`, { params: searchParams }).then((res) => {
        const { data } = res;
        setData(data);
      });
      return;
    }
    const timeOut = setTimeout(() => {
      const searchParams = new URLSearchParams();
      if (filterName) {
        searchParams.set('name', `${filterName}`);
      }
      if (filterCode) {
        searchParams.set('code', `${filterCode}`);
      }
      if (filterZoneId) {
        searchParams.set('zone_id', `${filterZoneId}`);
      }
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);
      api.get<TableResponse<Area>>(`/area/table`, { params: searchParams }).then((res) => {
        const { data } = res;
        setData(data);
      });
    }, 500);
    return () => clearTimeout(timeOut);
  }, [filterName, filterCode, filterZoneId, page, rowsPerPage]);
  return (
    <Container>
      <PageHeader text="พื้นที่" />
      <Grid container spacing={2} marginTop={1}>
        <Grid item md={3}>
          <TextField
            id="search-text-label"
            label="ค้นหารหัสพื้นที่"
            variant="outlined"
            placeholder="ค้นหารหัสพื้นที่"
            onChange={(event) => setFilterCode(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            autoComplete={'off'}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            id="search-text-label"
            label="ค้นหาชื่อพื้นที่"
            variant="outlined"
            placeholder="ค้นหาชื่อพื้นที่"
            onChange={(event) => setFilterName(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            autoComplete={'off'}
          />
        </Grid>
        <Grid item md={3}>
          <AreaZoneFromInput
            value={filterZoneId}
            onChange={(value) => setFilterZoneId(value)}
            canSelectAll
          />
        </Grid>

        <Grid item md sx={{ display: 'flex', justifyContent: 'end', height: '50px' }}>
          <Button component={Link} to={`/area/create`} variant="contained" color="primary">
            เพิ่มข้อมูล
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ mt: 2 }}>
        <Table
          heads={tableHead}
          count={data?.total ? data.total : 0}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        >
          {data?.data.map((data, index) => (
            <TableRow key={index}>
              <TableCell align="center">{data.area_code}</TableCell>
              <TableCell align="center">{data.area_name}</TableCell>
              <TableCell align="center">{data.zone?.zone_name}</TableCell>
              <TableCell align="center">
                <IOSSwitch
                  defaultChecked={data.is_require_wpm}
                  onChange={(_, checked) =>
                    updateAreaData(data.id, {
                      is_require_wpm: checked
                    })
                  }
                />
              </TableCell>
              <TableCell align="center">
                <Grid container spacing={2} rowSpacing={2} justifyContent="center">
                  <Grid item>
                    <Button
                      component={Link}
                      to={`/area/${data.id}/edit`}
                      variant="contained"
                      color="warning"
                    >
                      แก้ไข
                    </Button>
                  </Grid>
                </Grid>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </Box>
    </Container>
  );
};

export default AreaPage;

const Container = styled('div')`
  padding: 24px;
`;
